package com.exura.features.legacyplans.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class TimelyCheckup(
    override val id: String,
    override var planId: String,
    override val instructionId: String,
    override val seriesId: String,
    override val startFrom: LocalDateTime,
    override val endAt: LocalDateTime,
    override val notificationId: Int,
    val title: String,
    val description: String,
    val sensitive: Boolean,
    val imageUrl: String,
    val videoUrl: String,
    val answerWindow: AnswerWindow,
    val yesWithinWindow: Answer,
    val yesOutsideWindow: Answer,
    val noWithinWindow: Answer,
    val noOutsideWindow: Answer,
    val doneAt: LocalDateTime? = null, // TODO: just temp because of mimicing old BE
) : TimelyElement
